import React, { useState } from 'react';
import { PageHeader } from "./PageHeader";
import { DataBox } from "./DataBox";
import { Spin } from 'antd';
import { useFiltrationModel } from '../filtrationModel';

export function Filtration() {
    const { loading } = useFiltrationModel();

    return (
        <Spin tip="列表加载中" spinning={loading}>
            <PageHeader />
            <DataBox />
        </Spin>
    )
}

